import gql from 'graphql-tag';

export default gql`
  fragment FlightOptionFragment on FlightOption {
    id
    flight {
      id
      number
      operatedBy {
        carrier
        flightNo
      }
      origin {
        displayName
        code
      }
      destination {
        code
        displayName
      }
      departingTime
      arrivalTime
      isOvernight
      providerId
    }
    strikethruPrice
    price
    baseFare
    availableSeatsCount
    discountType
    totalDiscountValue
    incentiveType
    incentiveSavedAmount
    incentiveReturnDate
    onTimePerformance {
      onTimeArrival
      thirtyMinuteLate
      cancellations
      disclaimer
    }
    bundleReferences
    flightFares {
      fareName
      strikethruPrice
      price
      baseFare
      availableSeatsCount
      discountType
      totalDiscountValue
      incentiveType
      incentiveSavedAmount
      incentiveReturnDate
      bundleReferences
    }
    __typename
  }
`;
